export const isPreviewImageMissing = (previews) => !previews?.getIn?.([0, 'image', 'url'])
